import { useScrollPosition } from '@as/cotopaxi';
import { useState, useEffect } from 'react';
import { NAVIGATION_HORIZONTAL, NAVIGATION_HORIZONTAL_COLLAPSE, NAVIGATION_HEIGHT_MOBILE, } from '../../../constants/DOMElementsConstants';
const FOLDER_NAVIGATION_SELECTOR = 'div[data-hypernova-key=AEMScenes_FolderNavigation]';
export const FolderNavigationDisplayHandler = ({ setIsFolderNavigationDisplayed, }) => {
    const [navigationEl, setNavigationEl] = useState();
    const [folderNavigationElements, setFolderNavigationElements] = useState([]);
    const displayHandler = (folderNavigation, navigation) => {
        if (!folderNavigation) {
            return;
        }
        const isNavDisplayed = !!navigation && !navigation.classList.contains(NAVIGATION_HORIZONTAL_COLLAPSE);
        const isFolderNavigationDisplayed = folderNavigation.some(el => {
            const { top, bottom } = el.getBoundingClientRect();
            return (((isNavDisplayed ? top - NAVIGATION_HEIGHT_MOBILE : top) > 0 && top < window.innerHeight) ||
                ((isNavDisplayed ? bottom - NAVIGATION_HEIGHT_MOBILE : bottom) > 0 && bottom < window.innerHeight));
        });
        setIsFolderNavigationDisplayed(isFolderNavigationDisplayed);
    };
    useEffect(() => {
        const navigation = document.querySelector(NAVIGATION_HORIZONTAL);
        const folderNavigation = Array.from(document.querySelectorAll(FOLDER_NAVIGATION_SELECTOR));
        setNavigationEl(navigation);
        setFolderNavigationElements(folderNavigation);
        displayHandler(folderNavigation, navigation);
    }, []);
    useScrollPosition(() => {
        displayHandler(folderNavigationElements, navigationEl);
    }, [navigationEl, folderNavigationElements]);
    return null;
};
